import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export function authGuard(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> | void {
    const authStore = useAuthStore();
    if (to.path === '/login' && authStore.isAuthenticated) {
        // Redirect admin users to /admin, others to /home
        if (authStore.isAdmin()) {
            return next('/admin')
        }
        return next('/home')
    }

    if (!to.meta.authRequired || authStore.isAuthenticated) {
        return next();
    } else {
        authStore.saveRedirectRoute(to);
        return next({ name: 'login' });
    }
}